import React, { Component } from 'react';
import Anchor from "../../../../dashboardNew/objects/Anchor";
import BackButton from "../../../../dashboardNew/components/tools/BackButton";

class EventInfo extends Component {

    render() {
        const { event } = this.props;
        const currentEvent = Array.isArray( event ) ? event[0] : event;
        const image = currentEvent.image;
        return (
            <div className="portal-page-wrapper events-page-inner" data-aos>
                <div className="image" style={{backgroundImage: `url(${image})`}}></div>
                <div className="container inner-content">
                    <div className="row">
                        <div className="col-12 col-md-8">
                            <BackButton
                                title="Events List"
                                path="/events"
                            />
                            <h1 className="heading-main">{currentEvent.name}</h1>
                            <h3 className="heading-two">{currentEvent.city}</h3>
                            <p className="body-copy">{currentEvent.description}</p>
                            <Anchor path={currentEvent.url} anchorClass="theme-button" target>
                                Go to event
                            </Anchor>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default EventInfo;


// WEBPACK FOOTER //
// src/client/components/site/features/events/elements/EventInfo.js